import * as React from 'react';
import { Avatar, Menu, MenuDivider, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import { PersonRegular, RocketRegular, SignOutRegular } from '@fluentui/react-icons';
import type { AccountInfo } from '@azure/msal-browser';
import { Wordmark } from './Brand';
import { ENVIRONMENT_LABEL } from '../config';
import { signOut } from '../auth';
import { PRODUCT_NAME, UPGRADE_MAIL } from './product';


/**
 * The header on every signed-in screen, always the same: the product on the left (back to Today),
 * finding a client or file number, and the person's profile on the right (Account, Upgrade, Sign out).
 */
export function AppHeader(props: { account: AccountInfo; trial?: boolean; search?: boolean }): React.ReactElement {
  const name: string = props.account.name || props.account.username;
  const [q, setQ] = React.useState<string>('');
  return (
    <header className="app-header">
      <a href="#/home" className="app-header-brand" aria-label={`${PRODUCT_NAME} home`}>
        <Wordmark size={24} />
        {ENVIRONMENT_LABEL && <span className="env-badge">{ENVIRONMENT_LABEL}</span>}
      </a>
      <div className="app-search">
        {props.search && (
          <form role="search" style={{ display: 'flex', flex: 1, minWidth: 0 }} onSubmit={e => { e.preventDefault(); window.location.hash = `/clients?q=${encodeURIComponent(q.trim())}`; setQ(''); }}>
            <input type="search" aria-label="Find a client or file number" placeholder="Find a client or file number" value={q} onChange={e => setQ(e.target.value)} />
          </form>
        )}
      <Menu positioning="below-end">
        <MenuTrigger disableButtonEnhancement>
          <button type="button" className="profile-btn" aria-label={`Your account: ${name}`} title={name}>
            <Avatar name={name} size={36} color="neutral" />
          </button>
        </MenuTrigger>
        <MenuPopover>
          <div className="profile-who">
            <strong>{props.account.name || 'Signed in'}</strong>
            <span className="small">{props.account.username}</span>
          </div>
          <MenuDivider />
          <MenuList>
            <MenuItem icon={<PersonRegular />} onClick={() => { window.location.hash = '/settings'; }}>Account</MenuItem>
            {props.trial && <MenuItem icon={<RocketRegular />} onClick={() => { window.location.href = UPGRADE_MAIL; }}>Upgrade</MenuItem>}
            <MenuItem icon={<SignOutRegular />} onClick={() => { void signOut(); }}>Sign out</MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
      </div>
    </header>
  );
}
